// src/router.js
import { createRouter, createWebHistory } from 'vue-router';
import HomePage from './components/HomePage.vue';
import ContactPage from './components/ContactPage.vue';
import MobileApp from './components/MobileApp.vue';
import Websites from './components/WebSites.vue';
import TermsOfUse from './components/TermsOfUse.vue';
import PrivacyPolicy from './components/PrivacyPolicy.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactPage
  },
  {
    path: '/mobile-app',
    name: 'Mobile App',
    component: MobileApp
  },
  {
    path: '/websites',
    name: 'Websites',
    component: Websites
  },
  {
    path: '/terms-of-use',
    name: 'Terms of Use',
    component: TermsOfUse
  },
  {
    path: '/privacy-policy',
    name: 'Privacy Policy',
    component: PrivacyPolicy
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  // Lets links like /privacy-policy#delete-data (the Play Console deletion
  // URL) land on that section instead of the top of the page.
  scrollBehavior(to) {
    if (to.hash) {
      return { el: to.hash, behavior: 'smooth' };
    }
    return { top: 0 };
  }
});

export default router;
